import styled from "styled-components";

export const FooterContainer = styled.div<{ showFooterOverHalfCard?: boolean; isPlatformIos?: boolean }>(
    ({ theme, showFooterOverHalfCard, isPlatformIos }) => ({
        position: "fixed",
        background: theme.colors[theme.colorMode].background_Primary,
        left: 0,
        bottom: 0,
        width: "100%",
        boxShadow: `${theme.spacing.empty} calc(${theme.spacing.xxSmall} * -1) ${theme.spacing.xSmall} ${theme.spacing.empty} rgba(27, 30, 36, 0.04)`,
        borderRadius: theme.cornerRadius.none,
        transform: "translate3d(0, 0, 0)",
        paddingBottom: `calc(var(--sab, 0px) + ${theme.spacing.medium})`,
        zIndex: 2,
        "html.ios &": {
            "@supports (padding-bottom: env(safe-area-inset-bottom))": {
                /* As per cart v2 design, the padding-bottom should be 8px less than the safe-area-inset-bottom */
                paddingBottom: `calc(max(env(safe-area-inset-bottom) - ${theme?.spacing?.xSmall}, ${theme?.spacing?.medium}))`,
            },
        },
        "@keyframes zIndexDelay": {
            "0%, 99%": { zIndex: 2 },
            "100%": { zIndex: 999 },
        },
        // This is used to ensure that the footer is always on top of the half card when it is opened this is specifically for toing price comparison halfcard
        ...(showFooterOverHalfCard && {
            animation: "zIndexDelay 500ms step-end forwards",
            paddingBottom: theme.spacing.medium,
            borderRadius: theme.spacing.x9,
            left: "8px",
            right: "8px",
            width: "auto",
            margin: `0 ${theme.spacing.xSmall}`,
            marginBottom: isPlatformIos ? theme.spacing.medium : theme.spacing.xxLarge,
        }),
    }),
);
